<template>
  <component
          :is="as"
          :alt="alt"
          :class="className"
          :loading="loading"
          :media="media"
          :sizes="sizes"
          :type="formats[format]"
          v-bind="exposeOnly ? {'data-srcset': srcset.join(', ')} : {'srcset': srcset.join(', ')}"
  />
</template>

<script lang="ts" setup>
const {uri, dimensions, sizes, media = undefined, format = 'jpg', as = 'img', className = '', alt = '', loading = 'lazy'} = defineProps<{
    uri: string,
    dimensions: { width: number, height?: number }[],
    sizes: string,
    media?: string,
    format?: keyof typeof formats,
    as?: string,
    className?: string,
    alt?: string,
    loading?: string,
    exposeOnly: boolean
}>()
const formats = {
    webp: 'image/webp',
    jpg: 'image/jpeg',
    png: 'image/png',
}
const img = useImage()
const srcset = computed(() => {
    return dimensions.map(dimension =>
            `${img(uri, {
                ...dimension,
                format,
            })} ${dimension.width}w`,
    )
});

const baseUrl = useRequestURL();


useHead({
    meta: dimensions.map(dimension => {
        const url = img(uri, {
            ...dimension,
            format,
        });
        return {
            name: `prerender:image:${uri}:${dimension.width}w`,
            content: url
        }
    })
});
</script>
